import {Size} from 'constants/UIComponentEnum';
import {FmlxIcon, FmlxPopover} from 'fmlx-common-ui';
import {memo, useState} from 'react';

function PopupPipettingTipPositionInfo() {
  const [anchorEl, setAnchorEl] = useState(null);

  const onHoverHandler = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const onLeaveHandler = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div onMouseEnter={onHoverHandler} onMouseLeave={onLeaveHandler}>
        <FmlxIcon name="Info" size={Size.XS} />
      </div>
      <FmlxPopover anchorEl={anchorEl} isOverlay={false} anchorReference="anchorEl">
        <div style={{display: 'grid', gridTemplateColumns: '44% 45%', padding: '10px', gap: '5px'}}>
          <img src="./svg/protocol-editor/tip-position-high.svg" alt="High" />
          <img src="./svg/protocol-editor/tip-position-direction.svg" alt="Direction" />
        </div>
      </FmlxPopover>
    </>
  );
}

export default memo(PopupPipettingTipPositionInfo);
